import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexXAxis } from 'ng-apexcharts';
import { BehaviorSubject, Observable } from 'rxjs';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ProductServicesService } from 'src/app/services/settings-services/product-services.service';
import DateUtils from "../../utils/date";

export type ApexChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  colors: string[]
};

@Component({
  selector: 'app-product-report',
  templateUrl: './product-report.component.html',
  styleUrls: ['./product-report.component.css']
})

export class ProductReportComponent implements OnInit {
  showOption: boolean = false;
  yearList;
  dataValue;
  dateUtil = new DateUtils;
  productList = [];
  invoiceList = [];
  filteredSource: EventEmitter<any> = new EventEmitter<any>(null);
  productSource = {
    amount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
  };
  defaultData = {
    amount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
    count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
  };
  filter = {
    salesPersonTeam: '',
    year: new Date().getFullYear(),
    period: 'monthly',
    amountCount: 'count',
  };
  public chartOptions = {
    series: [
      {
        name: "terminated",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "due",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "active",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: "suspended",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ],
    chart: {
      type: "bar",
      height: 270
    },
    plotOptions: {
      bar: {
        horizontal: false,
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: 'Months',
      },
    },
    yaxis: {
      title: {
        text: 'Counts',
      },
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
  };
  productTableSource = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "Month", key: "month" },
      { title: "Active", key: "active" },
      { title: "Due", key: "due" },
      { title: "Suspended", key: "suspended" },
      { title: "Terminated", key: "terminated" },
    ],
    rows: [],
    options: {
      datePipe: {},
      singleActions: [],
      bulkActions: [],
      noOfRowsToDisplay: 5
    },
  };
  ViewSwitch = "Chart";

  constructor(
    private invoiceSvc: InvoiceService,
    private productSvc: ProductServicesService,
  ) {
    this.yearList = this.dateUtil.getYears();
  }

  async ngOnInit() {
    const invoiceList = await this.getAllInvoices();
    const productList = await this.getAllProductsAsync();
    this.filterSources(invoiceList, productList);
  }

  async onChangeFilters() {
    this.showOption = false;
    const invoiceList = await this.getAllInvoices();
    const productList = await this.getAllProductsAsync();
    this.filterSources(invoiceList, productList);
  }

  // Get All Invoices
  private async getAllInvoices() {
    const year = this.filter.year || new Date().getFullYear();
    const from = Date.parse(new Date(`01/01/${year}`).toISOString());
    const to = Date.parse(new Date(`12/31/${year}`).toISOString());
    const createdOn = { createdOn: { from: from, to: to } };
    let filterStrings = `range=${JSON.stringify(createdOn)}`;

    const { success, payload } = await this.invoiceSvc.getInvoiceByFilter(filterStrings).toPromise();
    if (success) {
      return payload;
    } else {
      return [];
      // throw toastr error
    }
  }

  // Get All Products
  private async getAllProductsAsync() {
    return await this.productSvc.getAllProductByCompany().toPromise();
  }

  //
  private filterSources(invoiceList, productList) {
    let productSource = {};
    let productNames = productList.map((res) => res.name);
    this.getProductInvTimes(invoiceList)
    return
  }

  productObj(products: any[]) {
    let result = {};
    products.forEach(p => {
      if (!p.itemName) {
        p.itemName = 'Unspecified'
      }
      result[p.itemName] = p
    });
    return result
  }

  getProductInvTimes(invoiceList: any[]) {
    let result = [];
    let allProducts = {}
    invoiceList.forEach(inv => {
      const products = inv.products;
      products.forEach(product => {
        if(typeof(product) === 'string') {
          product = JSON.parse(product);
        }
        if (!product.itemName) {
          product.itemName = 'Unspecified';
        }
        allProducts = { ...allProducts, [product.itemName]: product };
        const invProducts = new Array(product.quantity).fill({ ...inv, product: product.itemName });
        invProducts.forEach(p => result.push(p))
      })
    });
    const monthsCountRep = {};
    Object.keys(allProducts).forEach(p => {
      monthsCountRep[p] = {
        amount: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 },
        count: { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 }
      }
    });
    result.forEach(inv => {
      const monthNo = new Date(inv.createdOn).getMonth();
      if (monthsCountRep[inv.product]) {
        let monthCount = monthsCountRep[inv.product]['count'][monthNo];
        monthCount = monthCount + 1;
        monthsCountRep[inv.product]['count'][monthNo] = monthCount;
      }
    });
    // get highest prodducts
    const sortArray = [];
    Object.keys(monthsCountRep).forEach(product => {
      const productCounts = monthsCountRep[product].count;
      const productSumCount = this.sumUpCount(productCounts);
      sortArray.push({ name: product, count: productSumCount })
    });
    sortArray.sort((a, b) => {
      if (a.count > b.count) {
        return -1
      } else {
        return 1
      }
    })
    const topThreeProducts = sortArray.slice(0, 3);
    const finalResult = {};
    Object.keys(monthsCountRep).forEach(product => {
      if (topThreeProducts.findIndex(prod => prod.name == product) >= 0) {
        finalResult[product] = monthsCountRep[product];
      }
    });
    const graphSeries = [];
    Object.keys(finalResult).forEach(product => {
      const productCount = finalResult[product].count;
      graphSeries.push({ name: product, data: this.getProductDataArr(productCount) })
    });
    this.dataValue = graphSeries
    if (this.filter.period == "monthly") {
      this.chartOptions.xaxis.categories = ['Jan', 'Feb', 'March', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      this.chartOptions.series = this.dataValue;
      let tableData = []
      tableData = this.processMonthlyTableData(this.dataValue);
      const tableHead = tableData[0];
      const heads = []
      if (tableHead != undefined) {
        Object.keys(tableHead).forEach(key => {
          heads.push({ title: key, key })
        })
      }
      this.productTableSource.heads = heads
      this.productTableSource.rows = tableData;
      this.productTableSource.dataChangedObs.next(true);
      this.showOption = true;
    } else {
      const quaters = ['Q1', 'Q2', 'Q3', 'Q4']
      const quaterSeries = []
      Object.keys(finalResult).forEach(product => {
        const productCount = finalResult[product].count;
        const count = this.dateUtil.getQuarterlyData(productCount).quartersObj;
        quaterSeries.push({ name: product, data: this.getProductQuaterDataArr(count) })
      });
      this.chartOptions.series = quaterSeries;
      this.chartOptions.xaxis.categories = quaters;
      let quaterTableData = []
      quaterTableData = this.processQuaterlyTableData(quaterSeries);
      const tableHead = quaterTableData[0];
      const heads = []
      if (tableHead != undefined) {
        Object.keys(tableHead).forEach(key => {
          heads.push({ title: key, key })
        })
      }
      this.productTableSource.heads = heads
      this.productTableSource.rows = quaterTableData;
      this.productTableSource.dataChangedObs.next(true);
      this.showOption = true;
    }
  }

  private processMonthlyTableData(data) {
    const tableData = [];
    const getMonth = this.chartOptions.xaxis.categories;
    // Loop the months
    for (let i = 0; i < 12; i++) {
      const product1 = data[0] ? data[0].name : null;
      const product2 = data[1] ? data[1].name : null;
      const product3 = data[2] ? data[2].name : null;
      if (product1) {
        tableData[i] = { ...tableData[i], month: getMonth[i], [product1]: data[0].data[i] }
      }
      if (product2) {
        tableData[i] = { ...tableData[i], month: getMonth[i], [product2]: data[1].data[i] }
      }
      if (product3) {
        tableData[i] = { ...tableData[i], month: getMonth[i], [product3]: data[2].data[i] }
      }
    }
    return tableData;
  }

  private processQuaterlyTableData(data) {
    const tableData = [];
    const quaters = ['Q1', 'Q2', 'Q3', 'Q4']
    // Loop the months
    for (let i = 0; i < 4; i++) {
      const product1 = data[0] ? data[0].name : null;
      const product2 = data[1] ? data[1].name : null;
      const product3 = data[2] ? data[2].name : null;
      if (product1) {
        tableData[i] = { ...tableData[i], month: quaters[i], [product1]: data[0].data[i] }
      }
      if (product2) {
        tableData[i] = { ...tableData[i], month: quaters[i], [product2]: data[1].data[i] }
      }
      if (product3) {
        tableData[i] = { ...tableData[i], month: quaters[i], [product3]: data[2].data[i] }
      }
    }
    return tableData;
  }

  handleViewSwitch(view) {
    this.ViewSwitch = view;
  }

  private sumUpCount(counts) {
    const sum = counts[0] + counts[1] + counts[2] + counts[3] + counts[4] +
      counts[5] + counts[6] + counts[7] + counts[8] + counts[9] + counts[10] + counts[11];
    return sum;
  }

  private getProductDataArr(counts) {
    const arr = [counts[0], counts[1], counts[2], counts[3], counts[4],
    counts[5], counts[6], counts[7], counts[8], counts[9], counts[10], counts[11]];
    return arr;
  }

  private getProductQuaterDataArr(counts) {
    const arr = [counts[1], counts[2], counts[3], counts[4]];
    return arr;
  }
}
